import React from 'react';
import XlsUploader from 'components/base/xls-uploader';
import SelectBrand from 'components/select-brand';
import PageHeaderText from 'components/base/page-header-text';
import useNewMealXlsContext from 'contexts/new-meal-xls.context';
import XlsMealsImageUploader from '../image-uploader';
import { isFCShopCategory } from 'utils/functions';

const UploadXlsMeals = () => {
  const {
    imageFiles,
    setImageFiles,
    imageData,
    setImageData,
    xlsFile,
    setXlsFile,
    selectedBrand,
    setSelectedBrand,
    meals,
    setMeals
  } = useNewMealXlsContext();

  const isFcShop = isFCShopCategory();

  const _setImageFiles = (files: Array<File>) => {
    const filenames: Array<string> = [];
    const filesSet: Array<File> = [];
    if (files) {
      files = Array.from(files).filter((file) => meals.some((meal) => meal.Image === file.name));
    }
    for (const file of files) {
      if (!filenames.includes(file.name)) {
        filenames.push(file.name);
        filesSet.push(file);
      }
    }
    setImageFiles(filesSet);
  };

  return (
    <div>
      <PageHeaderText
        title='Add New Meal via xls'
        description='Create a new meal by uploading necessary files'
      />
      <div className='mb-6 space-y-2'>
        <p className='text-sm font-medium'>
          What {isFcShop ? 'shop' : 'brand'} should this meal be added to?
        </p>

        <SelectBrand
          brands={selectedBrand ? [selectedBrand] : []}
          setBrands={([b]) => setSelectedBrand(b)}
        />
      </div>
      <XlsUploader title='Add .xlsx file' setMeals={setMeals} file={xlsFile} setFile={setXlsFile} />
      {!isFcShop && (
        <div className='relative mt-6'>
          {!meals.length ? (
            <div
              title='Please upload a .xlsx file first'
              className='absolute z-[2] top-[1px] left-[1px] right-[1px] bottom-[1px] rounded-md bg-white/70 grayscale cursor-not-allowed'
            />
          ) : null}

          <XlsMealsImageUploader
            files={imageFiles}
            imageData={imageData}
            setImageData={setImageData}
            setFiles={_setImageFiles}
            disabled={!meals.length}
          />
        </div>
      )}
    </div>
  );
};

export default UploadXlsMeals;
